/**
 * Investment Card Component
 * Displays individual investment opportunity details
 * Extracted from original lines 747-779
 */

import { FC, CSSProperties } from "react";
import { COLORS } from "../../../constants/colors";
import { InvestmentOpportunity } from "../StructureNote.types";

interface InvestmentCardProps {
  data: InvestmentOpportunity;
  isSelected: boolean;
  isHovered: boolean;
  onSelect: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  disabled?: boolean;
}

/**
 * Individual investment opportunity card
 * Original logic from lines 747-779
 */
const InvestmentCard: FC<InvestmentCardProps> = ({
  data,
  isSelected,
  isHovered,
  onSelect,
  onMouseEnter,
  onMouseLeave,
  disabled,
}) => {
  // Original style logic from getBoxStyle (lines 320-343)
  const cardStyle: CSSProperties = {
    cursor: disabled ? "default" : "pointer",
    border: "1px solid #ccc",
    padding: "30px",
    borderRadius: "5px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    flex: 1,
    marginTop: "20px",
    display: "flex",
    flexDirection: "column",
    gap: 25,
    margin: "10px",
    backgroundColor: isSelected
      ? "rgba(0, 0, 0, 0.25)"
      : isHovered
      ? "rgba(0, 0, 0, 0.25)"
      : "transparent",
    color: isHovered || isSelected ? COLORS.whiteColor : undefined,
    transition: "background-color 0.3s ease",
  };

  const amountStyle: CSSProperties = {
    color: COLORS.agreementFont,
    fontWeight: "bold",
    fontSize: "22px",
  };

  return (
    <div
      style={cardStyle}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={disabled ? undefined : onSelect}
    >
      <p style={{ fontWeight: "bold" }}>
        Amount Available for
        <br /> Investment
      </p>
      <p style={amountStyle}>
        {data?.currency} {data?.amountAvailableForInvestment ?? "0"}
      </p>
      <p>Note : {data?.structuredNoteDisplayId}</p>
      <p>Tenor: {data?.tenor} days</p>
      <p>Interest Rate: {data?.snInterestRate} % p.a.</p>
      <p>Total SKU's: {data?.totalSKU}</p>
      <p>Total Merchants: {data?.totalMerchants}</p>
    </div>
  );
};

export default InvestmentCard;
